export default __webpack_public_path__ + "static/media/ProductFeedback.8d172e6c.png";